import { HttpErrorResponse } from '@angular/common/http';

export class ErrorUtil {
  public static getErrorMensagem(pError: unknown, pMensagemPadrao: string = 'Erro nao identificado'): string {
    let mensagemErro = '';

    if (pError instanceof Error) {
      mensagemErro = pError.message;
    } else if (pError instanceof HttpErrorResponse) {
      mensagemErro = this.getMensagemHttpErrorResponse(pError, pMensagemPadrao);
    } else if (typeof pError === 'string') {
      mensagemErro = pError;
    } else {
      mensagemErro = pMensagemPadrao;
    }

    return mensagemErro;
  }

  public static getMensagemHttpErrorResponse(pError: HttpErrorResponse, pMensagemPadrao: string): string {
    if (pError?.error?.message) {
      return pError.error.message;
    }
    if (pError?.error?.mensagem) {
      return pError.error.mensagem;
    }

    return pMensagemPadrao;
  }
}
